import { styled, Tab as MuiTab, Button, Avatar } from '@mui/material';

export const NotificationsHolder = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  width: 48,
  justifyContent: 'center',
}));

export const AvatarHolder = styled('div')(() => ({
  flexGrow: 0,
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const CustomAvatar = styled(Avatar)(({ theme }) => ({
  width: 48,
  height: 48,
  border: `3px solid ${theme.palette.common.white}`,
  boxSizing: 'border-box'
}));

export const Tab = styled(MuiTab)(({ theme }) => ({
  '&.Mui-selected': {
    color: `${theme.palette.primary.contrastText} !important`,
    outline: 'none',
  },
  '&.MuiTab-textColorPrimary': {
    color: `${theme.palette.alphas.halfWhite}`,
  },
}));

export const NavBarButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primaryAlternative.lighter,
  '&.active': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    path: {
      fill: theme.palette.primary.main,
    },
  },
  path: {
    fill: theme.palette.common.white,
  },
}));
